<template lang="html">
<div id="generador_archivos">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
    <v-container fluid fill-height>
      <v-row>
        <v-col xs="12">
          <base-material-card color="primary" icon="library_books" title="Generador de Archivos TXT" class="elevation-1 px-5 py-3">
            <v-card-text class="center">
              <v-card-title class="center">
                <v-spacer />
                <span v-if="existe" class="headline red--text">El informe ya ha sido cargado previamente</span>
                <v-spacer />
              </v-card-title>
              <div class="generador_archivos">
                <v-form ref="form" lazy-validation class="form_generador">
                  <v-container fluid>
                    <v-row align="center" dense>
                      <v-col sm="12">
                        <v-text-field v-model="model.folio_sat" label="Folio SAT" :key="folio_key" :rules="[rules.required]" @change="llena_campos" @blur="llena_campos" @keyup="llena_campos"/>
                      </v-col>
                      <v-col sm="12">
                        <v-autocomplete v-model="model.tipo" label="Tipo" :items="tipo_informes" item-value="id" item-text="text" @change="change_tipo" :rules="[rules.required]"/>
                      </v-col>
                      <v-col sm="12" v-if="model.tipo != 2">
                        <v-autocomplete v-model="model.periodo" label="Periodo" :items="periodos" item-value="id" item-text="text" @change="genera_folio(); cargar_pedimentos();" clearable return-object :rules="[rules.required]"/>
                      </v-col>
                      <v-col sm="12" v-if="model.tipo != 2">
                        <v-autocomplete v-model="model.destino" label="Clave Destino Aduanero" :items="destinos" item-value="id" item-text="text" @change="genera_folio(); cargar_pedimentos();" clearable return-object :rules="[rules.required]"/>
                      </v-col>
                      <v-col sm="12" v-if="model.tipo != 2">
                        <v-text-field v-model="model.ejercicio" label="Año" @change="cargar_pedimentos" @blur="genera_folio" v-mask="'####'" :rules="[rules.required]"/>
                      </v-col>
                      <v-col sm="12">
                        <v-text-field v-model="model.no_movimiento" label="No. Consecutivo" v-mask="'####'" @blur="genera_folio" @keyup="genera_folio" :rules="[rules.required]"/>
                      </v-col>
                      <v-col sm="12" v-if="model.tipo == 1 && !['51', '52', '53', '54'].includes(this.model.destino.numero)">
                        <v-autocomplete v-model="model.pedimentos" label="Pedimentos" :items="pedimentos" multiple small-chips deletable-chips item-value="id" item-text="descripcion" return-object :rules="[rules.required, rules.esArreglo]">

                          <template v-slot:prepend-item>
                            <v-list-item ripple @click="toggle">
                              <v-list-item-action>
                                <v-icon :color="model.pedimentos.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>Seleccionar Todos</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                        </v-autocomplete>

                      </v-col>
                      <!-- <v-col sm="10" md="4" v-if="['51', '52', '53', '54'].includes(this.model.destino.numero)">
                        <v-text-field v-model="folio_nuevo" label="Agregar Folio"/>
                      </v-col> -->

                      <v-col sm="10" v-if="['51', '52', '53', '54'].includes(this.model.destino.numero)">
                        <v-autocomplete v-model="model.folios" :items="model.folios" label="Folios" multiple small-chips deletable-chips :rules="[rules.required, rules.esArreglo]"/>
                      </v-col>
                      <v-col sm="2" v-if="['51', '52', '53', '54'].includes(this.model.destino.numero)">
                        <v-btn color="green" small fab @click="listado=''; dialog1 = !dialog1; model.folios = [];" title="Pegar Listado">
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>

                      <v-col v-if="model.tipo == 1" cols="12">
                          <v-autocomplete v-model="model.planta" label="Planta Referencia" :items="plantas" :hide-no-data="true" item-text="referencia" item-value="referencia" clearable />
                      </v-col>
                      <v-col sm="12">
                        <v-chip v-if="Array.isArray(model.archivo) && model.archivo.length > 0" class="ma-2" close color="green" outlined @click:close="model.archivo=''">Archivo Cargado Correctamente</v-chip>
                        <upload-excel-component v-if="model.tipo > 0 && model.archivo == ''" :on-success="handleSuccess" :before-upload="beforeUpload" :firstRow='2'/>
                      </v-col>
                    </v-row>
                    <br>
                    <v-row>
                      <v-col cols="12">
                        <v-card-title>
                          <v-spacer />
                          <v-btn v-if="model.tipo == 2" color="secondary" small @click="descargar_layout('inventario')">
                            <v-icon small>mdi-download</v-icon> Plantilla
                          </v-btn>
                          <v-btn v-else color="secondary" small @click="descargar_layout('descargo')">
                            <v-icon small>mdi-download</v-icon> Plantilla
                          </v-btn>
                          
                          <v-btn color="success" small @click="generar">
                            Generar
                          </v-btn>
                        </v-card-title>
                      </v-col>
                    </v-row>
                    <br>
                  </v-container>
                </v-form>
              </div>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </div>

  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de Folios</h5>
        <span>Uno por línea</span>
        <v-form ref="formListadoFolios" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListadoFolios]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="agregar_folio" >Agregar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  created: async function() {
    this.model = this.clean_model();
    await this.cargar_plantas();
    await this.cargar_periodos();
    await this.cargar_destinos();
    await this.get_anio_certificacion();
  },
  computed: {
    todosPedimentos() {
      return this.model.pedimentos.length === this.pedimentos.length
    },
    algunosPedimentos() {
      return this.model.pedimentos.length > 0 && !this.todosPedimentos
    },
    icon() {
      if (this.todosPedimentos) return 'mdi-close-box'
      if (this.algunosPedimentos) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  data: () => ({
    listado:'',
    dialog1: false,
    existe: false,
    folio_nuevo: '',
    anio_certi: '99',
    folio_key: 0,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
          text: "Informes TXT",
          disabled: true,
          href: ""
      },
      {
        text: "Generador de Archivos",
        disabled: true,
        to: ""
      }
    ],
    model: {},
    tipo_informes: [{
        "id": 1,
        "text": "Informe Descargo"
      },
      {
        "id": 2,
        "text": "Inventario Inicial"
      },
      // {
      //   "id": 3,
      //   "text": "DES"
      // },
      // {
      //   "id": 4,
      //   "text": "DON"
      // },
      // {
      //   "id": 5,
      //   "text": "CFDI"
      // },
      // {
      //   "id": 6,
      //   "text": "CTM"
      // }
    ],
    periodos: [],
    destinos: [],
    pedimentos: [],
    plantas: [],
    plantillas: {
      descargo: {
        encabezadoLayout: {
          "Fraccion": "fraccion",
          "Valor": "valor",
          "Identificador": "identificador"
        },
        camposLayout: [{
          fraccion: "[Fracción Arancelaria Numerico]",
          valor: "[Valor Comercial Numerico]",
          identificador: "[Identificador S/N]"
        }],
      },
      inventario: {
        encabezadoLayout: {
          "Patente": "patente",
          "Pedimento": "pedimento",
          "Aduana": "aduana",
          "Fecha de Entrada": "fecha_entrada",
          "Fraccion": "fraccion",
          "Valor": "valor",
          "Identificador": "identificador"
        },
        camposLayout: [{
          patente: "[Patente Número]",
          pedimento: "[Pedimento Número]",
          aduana: "[Aduana Número]",
          fecha_entrada: "[Fecha formato YYYY-MM-DD]",
          fraccion: "[Fracción Arancelaria Numerico]",
          valor: "[Valor Comercial Numerico]",
          identificador: "[Identificador S/N]"
        }],
      }
    },
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      },
      esArreglo: v => Array.isArray(v) && v.length > 0 || "Se deben agregar elementos a la lista"
    },

  }),
  methods: {
    validaListadoFolios: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 folio. Favor de verificar.";
      } else if (listadoSinEspacios.length > 50) {
        return "No se puede consultar mas de 50 Folios";
      }
      return true;
    },
    removerLineasVacias(listado) {
      var listadoSplit = this.listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      return listadoSinEspacios;
    },
    clean_model: function() {
      return {
        "rfc": this.$local_storage.get('rfc'),
        "folio_sat": "",
        "tipo": "",
        "periodo": "",
        "destino": "",
        "ejercicio": "",
        "folios": [],
        "no_movimiento": "",
        "pedimentos": [],
        "archivo": "",
        "planta": ""
      };
    },
    cargar_periodos: async function() {
      this.periodos = [];
      this.model.pedimentos = [];
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        tabla: 32,
      };
      await axios.post(this.$hostname + "apendices/lista/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            res.data.forEach((item) => {
              this.periodos.push({
                "id": item.id,
                "text": item.clave + " - " + item.nombre,
                "numero": item.clave,
              });
            });
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {
          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    cargar_destinos: async function() {
      this.destinos = [];
      this.model.pedimentos = [];
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        tabla: 30,
        rfc: this.$local_storage.get("rfc")
      };
      await axios.post(this.$hostname + "apendices/lista/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            res.data.forEach((item) => {
              this.destinos.push({
                "id": item.id,
                "text": item.clave + " - " + item.nombre,
                "numero": item.numero != null && item.numero != "" ? item.numero : '00'
              });
            });
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {
          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    cargar_pedimentos: async function() {
      if (this.model.tipo > 1) {
        return false;
      }
      if (this.model.periodo != null && this.model.periodo != "" && this.model.periodo != undefined &&
        this.model.destino != null && this.model.destino != "" && this.model.destino != undefined &&
        this.model.ejercicio != null && this.model.ejercicio != "" && this.model.ejercicio != undefined) {
        this.pedimentos = [];
        this.model.pedimentos = [];
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        var datos = {
          rfc: this.$local_storage.get("rfc"),
          destino: this.model.destino.id,
          periodo: this.model.periodo.id,
          ejercicio: this.model.ejercicio
        };

        await axios.post(this.$apiSA31 + "soluciona31/list_pedimentos_generador/", datos)
          .then(res => {
            if (typeof res.data !== "undefined") {
              this.pedimentos = res.data;
              this.$root.$dialogLoader.hide();
            }
          })
          .catch(err => {
            console.log(err);
            this.$root.$dialogLoader.hide();
            this.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un error al cargar los pedimentos",
              footer: ""
            });
          });
      }
    },
    cargar_plantas: async function() {
      let data = {
        cliente: this.$local_storage.get("id_cliente"),
      };
      await axios.post(this.$hostname + "catalogos/referencias/get_referencias/", data).then(res => {
        if (typeof res.data !== "undefined") {
          this.plantas = res.data;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    get_anio_certificacion: async function() {
      var datos = {
        rfc: this.$local_storage.get("rfc")
      };

      await axios.post(this.$apiSA31 + "soluciona31/get_certificacion_cliente/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.anio_certi = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {
          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    agregar_folio: function() {
      if (this.$refs.formListadoFolios.validate()) {
        this.model.folios = this.removerLineasVacias(this.listado);
        this.listado = String('')
        this.dialog1 = false;
      }

      // if (this.folio_nuevo == '' || this.folio_nuevo == null || this.folio_nuevo == undefined || this.folio_nuevo.trim() == "") {
      //   this.$swal({
      //     type: "warning",
      //     title: "¡Operación no Permitida!",
      //     text: "El Folio no puede ser nulo o vacio.",
      //     footer: ""
      //   });
      //   return false;
      // }
      //
      // if (this.model.folios.includes(this.folio_nuevo)) {
      //   this.$swal({
      //     type: "warning",
      //     title: "¡Operación no Permitida!",
      //     text: "El Folio ya fue agregado anteriormente",
      //     footer: ""
      //   });
      //   return false;
      // }
      // this.model.folios.push(this.folio_nuevo);
      // this.folio_nuevo = "";
    },
    change_tipo: function() {
      this.pedimentos = [];
      this.model.pedimentos = [];
      this.model.folios = [];
      this.model.archivo = "";
      this.genera_folio();
      this.cargar_pedimentos();
    },
    genera_folio: function() {
      this.folio_key += 1;
      this.model.folio_sat = this.$local_storage.get("rfc");

      if (this.model.tipo == null || this.model.tipo == '') {
        this.model.folio_sat += '--';
      } else if (this.model.tipo == 2) {
        this.model.folio_sat += '0100' + this.anio_certi + '01';

        if (this.model.no_movimiento == null || this.model.no_movimiento == '') {
          this.model.folio_sat += '----';
        } else {
          this.model.folio_sat += this.model.no_movimiento.padStart(4, '0');
        }

        var regex = /^([A-Za-z0-9\x26]{12,13})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{4})$/;
        var matches = regex.exec(this.model.folio_sat);
        if (matches != null && matches != undefined && matches.length == 7) {
          if (matches[2] == '02') {
            this.verifica_existe(1)
          } else {
            this.verifica_existe(2)
          }
        } else {
          console.log("no entra");
        }

        return;
      } else {
        this.model.folio_sat += '02'
      }

      if (this.model.destino == null || this.model.destino == '') {
        this.model.folio_sat += '--';
      } else {
        this.model.folio_sat += this.model.destino.numero;
      }

      if (this.model.ejercicio == null || this.model.ejercicio == '') {
        this.model.folio_sat += '--';
      } else {
        if (this.model.ejercicio.length == 4) {
          let ej = this.model.ejercicio.substring(2, 4).toString();
          this.model.folio_sat += ej;
        } else {
          this.model.folio_sat += '--';
        }
      }

      if (this.model.periodo == null || this.model.periodo == '') {
        this.model.folio_sat += '--';
      } else {
        this.model.folio_sat += this.model.periodo.numero;
      }

      if (this.model.no_movimiento == null || this.model.no_movimiento == '') {
        this.model.folio_sat += '----';
      } else {
        this.model.folio_sat += this.model.no_movimiento.padStart(4, '0');
      }

      var regex = /^([A-Za-z0-9\x26]{12,13})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{4})$/;
      var matches = regex.exec(this.model.folio_sat);
      if (matches != null && matches != undefined && matches.length == 7) {
        if (matches[2] == '02') {
          this.verifica_existe(1)
        } else {
          this.verifica_existe(2)
        }
      } else {
        console.log("no entra");
      }

    },
    beforeUpload: function(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (isLt2M) {
        return true;
      }
      this.$swal({
        type: "warning",
        title: "¡Operación no Permitida!",
        text: "El archivo no debe ser mayor a 2MB.",
        footer: ""
      });
      return false;
    },
    handleSuccess: function({
      results,
      header
    }) {
      // Validar el tipo 2 = Inventario Inicial
      if (this.model.tipo == 2) {
        var requeridos = Object.keys(this.plantillas.inventario.encabezadoLayout);
      } else {
        var requeridos = Object.keys(this.plantillas.descargo.encabezadoLayout);
      }

      var valido = true;
      var linea = 2;
      results.forEach((item, i) => {
        var keys = Object.keys(item);
        requeridos.forEach((item2) => {
          if (!keys.includes(item2)) {
            valido = false;
            linea = 2 + i;
          }
        });
      });

      if (!valido) {
        this.$swal({
          type: "info",
          title: "Validación",
          text: "El archivo cargado contiene errores en la linea " + linea,
          footer: "Por favor revisar que todos los campos esten llenos y con el formato correcto"
        });

        return;
      }

      if (this.model.tipo == 1) {
        var diferentes_sn = results.filter(item => !["S", "N"].includes(item['Identificador']));

        if (diferentes_sn.length > 0) {
          this.$swal({
            type: "info",
            title: "Validación",
            text: "El archivo cargado contiene diferentes tipos de identificadores",
            footer: "Por favor revisar que todos los campos esten llenos y con el formato correcto"
          });

          return;
        }

        var diferentes_fraccion = results.filter(item => item['Fraccion'].toString().length != 8);
        if (diferentes_fraccion.length > 0) {
          this.$swal({
            type: "info",
            title: "Validación",
            text: "El archivo cargado contiene diferentes tipos de fracciones",
            footer: "Por favor revisar que todos los campos esten llenos y con el formato correcto"
          });

          return;
        }
      }

      this.model.archivo = [];
      results.forEach((item) => {
        if (this.model.tipo == 1) {
          this.model.archivo.push({
            "fraccion": item['Fraccion'],
            "valor": item['Valor'],
            "identificador": item['Identificador']
          });
        } else {
          this.model.archivo.push({
            "patente": item['Patente'],
            "pedimento": item['Pedimento'],
            "aduana": item['Aduana'],
            "fecha_entrada": this.parseDateExcel(item['Fecha de Entrada']),
            "fraccion": item['Fraccion'],
            "valor": item['Valor'],
            "identificador": item['Identificador']
          })
        }

        console.log(this.model.archivo)
      });
    },
    parseDateExcel(excelDate) {
      try {
        if (!excelDate) return false;
        var fecha = '';
        if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
          fecha = moment(String(excelDate)).format("YYYY-MM-DD");
        else
          fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
        if (fecha == 'Invalid date') return false;
        return fecha;
      } catch (error) {
        return false;
      }
    },
    generar: function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!Array.isArray(this.model.archivo) || (Array.isArray(this.model.archivo) && this.model.archivo.length == 0)) {
        this.$swal({
          type: "info",
          title: "Validación",
          text: "Debes cargar una plantilla con información requerida",
          footer: ""
        });

        return;
      }

      if(this.existe) {
        return;
      }

      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var data = this.model;

      if (data['planta'] == null || data['planta'] == "" || data['planta'] == undefined) {
        delete data['planta'];
      }

      // {
      //   "id": 3,
      //   "text": "DES"
      // },
      // {
      //   "id": 4,
      //   "text": "DON"
      // },
      // {
      //   "id": 5,
      //   "text": "CFDI"
      // },
      // {
      //   "id": 6,
      //   "text": "CTM"
      // }

      if (['51', '52', '53', '54'].includes(data['destino']['numero'])) {
        if(data['destino']['numero'] == '52') {
          data['tipo'] = 3;
        } else if(data['destino']['numero'] == '53') {
          data['tipo'] = 4;
        } else if(data['destino']['numero'] == '51') {
          data['tipo'] = 5;
        } else {
          data['tipo'] = 6;
        }
      }


      var url = this.$apiSA31 + "soluciona31/generador_txt/";
      var url_test = "http://localhost:8000/soluciona31/generador_txt/";

      axios.post(url, data).then(response => {
          this.model = this.clean_model();
          this.$swal({
            type: "success",
            title: "Operación Exitosa",
            text: "El TXT se generó y procesó correctamente",
            footer: ""
          });
        })
        .catch(error => {
          let mensaje;
          var titulo = "¡Operación no Permitida!";
          var tipo = "error";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined) {
            mensaje = error.response.data.mensaje;
          } else if(Array.isArray(error.response.data)) {
            mensaje = error.response.data.toString();
          }
          else {
            mensaje = "Ocurrió un error reportalo con el administrador.";
          }
          this.$swal({
            type: tipo,
            title: titulo,
            text: mensaje,
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    llena_campos: function() {
      var regex = /^([A-Za-z0-9\x26]{12,13})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{4})$/;
      var matches = regex.exec(this.model.folio_sat);
      if (matches != null && matches != undefined && matches.length == 7) {
        if (matches[2] == '02') {
          //Es un descargo
          this.model.tipo = 1;
          this.model.ejercicio = "20" + matches[4];
          this.model.no_movimiento = matches[6];

          var dest = this.destinos.filter(x => x.numero.toString() == matches[3])
          this.model.destino = dest.length > 0 ? dest[0] : null;

          var per = this.periodos.filter(x => x.numero.toString() == matches[5])
          this.model.periodo = per.length > 0 ? per[0] : null;
        } else {
          //Es inventario
          this.model.tipo = 2;
          this.model.no_movimiento = matches[6];
        }

        this.verifica_existe(this.model.tipo);
      }
    },
    verifica_existe: function(tipo) {
      var url = tipo == 1 ? this.$apiSA31 + "soluciona31/list_informes_descargo/" : this.$apiSA31 + "soluciona31/list_inventarios_iniciales/";
      if (tipo == 1) {
        var data = {
          "filtros": {
            "folio": this.model.folio_sat,
            "estatus": {
              "$ne": "Faltante"
            }
          },
          "rfc": this.model.rfc,
          "campos": {
            "rfc": 1,
            "cabecera":1
          }
        };
      } else {
        var data = {
          "filtros": {
            "folio": this.model.folio_sat,
            "faltante": {
              "$ne": 1
            }
          },
          "rfc": this.model.rfc,
          "campos": {
            "rfc": 1
          }
        };
      }

      this.existe = false;
      axios.post(url, data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.cargar_pedimentos();
            if (res.data.length > 0) {
              this.existe = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    toggle() {
      if (this.todosPedimentos) {
        this.model.pedimentos = []
      } else {
        this.model.pedimentos = this.pedimentos.slice()
      }
    },
    descargar_layout: function(tipo) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      var key = tipo == 'descargo' ? 'LayoutTxTDescargo.xlsx' : 'LayoutTxTInventario.xlsx';

      var datos = {
          id: key,
          bucket: "descargas.econnectpro.mx"
      }
      let nombre_download = key.split("/").pop();
      axios.post(this.$hostname + "s3/download/", datos, {
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Allow": "POST",
              "cache-control": "no-cache",
          })
          .then(response => {
              var bytes = this.base64ToArrayBuffer(response.data);
              let blob = new Blob([bytes], {
                      type: response.headers["content-type"]
                  }),
                  url = window.URL.createObjectURL(blob);

              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = url;
              a.download = nombre_download;
              a.click();
              a.parentNode.removeChild(a);
          })
          .catch(error => {
              console.log(error);

          }).then(() => {
              this.$root.$dialogLoader.hide();
          });
    },
    base64ToArrayBuffer: function (base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    },
  },
}
</script>

<style lang="css" scoped>

.generador_archivos {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form_generador {
  width: 70%;
  border-radius: 15px;
  border: 1px solid lightgray;
}
</style>
